import { MenuItem } from "@voicely/ui-mui/form/MenuItem";
import { TextField } from "@voicely/ui-mui/form/TextField";

/** The windows the backend caps at (168h); the labels say what the numbers mean. */
const WINDOWS = [
	{ hours: 1, label: "Last hour" },
	{ hours: 6, label: "Last 6 hours" },
	{ hours: 24, label: "Last 24 hours" },
	{ hours: 72, label: "Last 3 days" },
	{ hours: 168, label: "Last 7 days" },
];

export const HoursField = ({
	value,
	onChange,
}: {
	value: number;
	onChange: (hours: number) => void;
}) => (
	<TextField
		select
		size="small"
		label="Window"
		value={value}
		onChange={(event) => onChange(Number(event.target.value))}
		sx={{ minWidth: 160 }}
	>
		{WINDOWS.map((window) => (
			<MenuItem key={window.hours} value={window.hours}>
				{window.label}
			</MenuItem>
		))}
	</TextField>
);
